import Vue from 'vue'
import 'moment/locale/pt'
import moment from 'moment'

Vue.filter('toDateFormat', (value, format) => {
  return moment(value).format(format)
})